<template>
  <b-row>
    <b-col cols="4" md="4" class="text-center">
      <p class="my-0 font-weight-light">
        <v-icon class="body-1" color="black">fas fa-plane-departure</v-icon>
        {{ resumen[0].salida.aeropuerto.codigo }}
      </p>
      <p class="caption font-weight-light">{{ resumen[0].salida.fecha | formatDate2Cliente }} hs</p>
    </b-col>
    <b-col cols="4" md="4" class="text-center">
      <div class="wrap">
        <div class="links">
          <div class="dot" v-for="(s, indexd) in resumen.length + 1" :key="indexd"></div>
        </div>
      </div>
      <div v-if="resumen.length - 1 == 1">
        <p class="my-0">
          <span class="text-warning caption">
            1 escala
          </span>
          <span
            @click="openItinerario = !openItinerario"
            class="cur-pointer"
            aria-controls="itinerario"
            :aria-expanded="openItinerario ? 'true' : 'false'"
          >
            <v-icon class="body-1" color="black">{{ openItinerario ? "fas fa-angle-up" : "fas fa-angle-down" }}</v-icon>
          </span>
        </p>
      </div>
      <div v-else-if="resumen.length - 1 > 1">
        <p class="my-0">
          <span class="text-warning caption"> {{ resumen.length }} escalas </span>
          <span
            @click="openItinerario = !openItinerario"
            class="cur-pointer"
            aria-controls="itinerario"
            :aria-expanded="openItinerario ? 'true' : 'false'"
          >
            <v-icon class="body-1" color="black">{{ openItinerario ? "fas fa-angle-up" : "fas fa-angle-down" }}</v-icon>
          </span>
        </p>
      </div>
      <div v-else>
        <p class="my-0">
          <span class="text-success caption">
            Sin escalas
          </span>
          <span
            @click="openItinerario = !openItinerario"
            class="cur-pointer"
            aria-controls="itinerario"
            :aria-expanded="openItinerario ? 'true' : 'false'"
          >
            <v-icon class="body-1" color="black">{{ openItinerario ? "fas fa-angle-up" : "fas fa-angle-down" }}</v-icon>
          </span>
        </p>
      </div>
    </b-col>
    <b-col cols="4" md="4" class="text-center">
      <p class="my-0 font-weight-light">
        <v-icon class="body-1" color="black">fas fa-plane-arrival</v-icon>
        {{ resumen[resumen.length - 1].llegada.aeropuerto.codigo }}
      </p>
      <p class="caption font-weight-light">{{ resumen[resumen.length - 1].llegada.fecha | formatDate2Cliente }} hs</p>
    </b-col>
    <b-col cols="12" md="12">
      <b-collapse class="my-2" :id="'collapse' + idxcupo" v-model="openItinerario">
        <ItinerarioCupo :itinerario="resumen" />
      </b-collapse>
    </b-col>
  </b-row>
</template>

<script>
import ItinerarioCupo from "@/components/cupos/ItinerarioCupo.vue"
export default {
  props: ["resumen", "idxcupo"],
  mounted() {},
  methods: {},
  components: {
    ItinerarioCupo
  },
  data: function() {
    return {
      openItinerario: false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*Indicadores escalas*/
.wrap {
  text-align: center;
  margin: 20px;
  position: relative;
}

.links {
  display: flex;
  justify-content: space-between;
  position: relative;
}
.wrap:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  border-top: 1px solid black;
  background: black;
  width: 100%;
  transform: translateY(-50%);
}
.dot {
  width: 5px;
  height: 5px;
  background: #ba093f;
  border-radius: 50%;
}
/* FIN Indicadores escalas*/
</style>
